// static/src/stores/crashState.js
// Tiny module-level singleton (not a Pinia store — this must work even if
// Pinia itself is what's crashing) tracking uncaught JS errors app-wide.
// main.js's app.config.errorHandler sets it; App.vue reads it to swap
// <router-view> for <CrashFallback>.

import { ref } from 'vue';

export const hasCrashed = ref(false);
export const crashDetail = ref('');

export function reportCrash(err) {
  console.error('💥 Uncaught application error:', err);
  hasCrashed.value = true;
  crashDetail.value = err?.message || String(err) || '';
}
